export const MMV_MODAL_COPY = {
    ['MAKE']: 'car brand',
    ['MODEL']: 'model',
    ['VARIANT']: 'variant',
    ['FUEL_TYPE']: 'fuel type',
    ['COLOR_TYPE']: 'color type',
};
